import {Button} from "../../@types/mainBannerButtonLinksResources.tsx";

export const FaqBannerButtonLinksConfig: Button[] = [
    {
        to: 'consult',
        text: 'contact_us',
        className: 'd-block d-sm-inline mb-3 me-sm-2 mb-sm-0 text-center opy-button'
    }
]
